import React, { useState, useEffect } from "react";
import logo from "../../img/Auth_logo_crypto_veche.svg";

import "./Authorization.scss";
import { useNavigate } from "react-router-dom";
import { Validation } from "../../utils/Validation";
import { useAuthTypes } from "../../hooks/useAuthTypes";
import AuthByEmail from "./AuthByEmail";
import AuthByPhone from "./AuthByPhone";
import * as Auth from "../../Api/Auth";
import * as Events from "../../Api/Events";
import AuthorizationTwoFactor from "../AuthorizationTwoFactor/AuthorizationTwoFactor";
import useCurrentUserContext from "../../hooks/useCurrentUserContext";
import {defaultContext} from "@tanstack/react-query";

const Authorization = (props) => {
  const {
    authError,
    preLoaderBtn,
    config,
    setAuthError,
    requestHelper,
    setLoggedIn,
    addCurrentUser,
    createUserName,
    setOffset,
    eventWaitingIdByLink,
    eventQuestionsIdByLink,
    eventResultIdByLink,
    handleCurrentEvents,
    showEventResult,
  } = props;

  const { setTwoFactorAuthLoginDate } = useCurrentUserContext();
  const navigate = useNavigate();
  const [isRememberMe, setIsRememberMe] = useState(true);
  const [isActiveEnterCheck, setIsActiveEnterCheck] = useState(false);
  const [activeBtnDisactiveSMS, setActiveBtnDisactiveSMS] = useState(false);
  const [disactiveInputPhone, setDisactiveInputPhone] = useState(false);
  const [activeSMSFieldConfirmBtn, setActiveSMSFieldConfirmBtn] = useState(false);
  const authTypes = useAuthTypes();
  const isLoadedTypes = !!Object.keys(authTypes).length;
  const [emailView, setEmailView] = useState(authTypes.email);
  const [changeAuthPhoneEnterSMS, setChangeAuthPhoneEnterSMS] = useState(false);
  const [changeAuthPhoneEnterPass, setChangeAuthPhoneEnterPass] = useState(true);
  const [authPhoneCodeError, setAuthPhoneCodeError] = useState("");
  const phoneView = !emailView;
  const activeTypeDisplay = config.type;
  const email = Validation();
  const emailPassword = Validation();
  const emailCode = Validation();
  const phone = Validation();
  const phonePassword = Validation();
  const phoneCode = Validation();
  const [passwordType, setPasswordType] = useState("password");
  const [isTwoFactor, setTwoFactor] = useState(false);
  const [isNotActiveBtn, setActiveBtn] = useState(false);

  const getPassword = () => {
    // console.log("password Type: ", passwordType);
    if (passwordType === "password") {
      return emailView ? emailPassword.value : phonePassword.value;
    }

    if (passwordType === "temporary-code") {
      return emailView ? emailCode.value : phoneCode.value;
    }

    return "";
  };

  useEffect(() => {
    let isMounted = true;
    isMounted && setEmailView(authTypes.email);
    return () => {
      isMounted = false;
    }
  }, [authTypes, isLoadedTypes]);

  const onMethodEnterTwoFactor = async () => {
    const getPass = getPassword();

    let dataLogin = {
      username: emailView ? email.value : phone.value,
      password: getPass,
      type: `${emailView ? "email" : "phone"}/${passwordType}`,
    }

    const loginResponse = await Auth.getVerificationCode({
      username: emailView ? email.value : phone.value,
      password: getPass,
      type: `${emailView ? "email" : "phone"}/${passwordType}`,
    });

    if (loginResponse?.status === 400 || loginResponse?.status === 403) {
      setAuthError("Неверный логин или пароль");
      // setPreloaderAuthBtn(false);
      return;
    }

    if (loginResponse?.status === 401) {
      setAuthError("Неверный логин или пароль");
      // setPreloaderAuthBtn(false);
      return;
    }

    if (loginResponse?.status === 429) {
      setAuthError('Превышен лимит отправляемых запросов, попробуйте позже');
      return;
    }

    if (loginResponse?.status) {
      setAuthError(`Ошибка сервера: ${loginResponse.status}`);
      return;
    }

    setActiveBtn(true);
    setAuthError('');
    setTwoFactorAuthLoginDate(dataLogin)
    setTwoFactor(true);
  }

  const onMethodEnterLogin = async () => {
    const getPass = getPassword();

    const loginResponse = await Auth.login({
      username: emailView ? email.value : phone.value,
      password: getPass,
      type: `${emailView ? "email" : "phone"}/${passwordType}`,
    });

    if (loginResponse?.status === 400) {
      setAuthError("Неверный логин или пароль");
      // setPreloaderAuthBtn(false);
      return;
    }

    if (loginResponse?.status === 401) {
      setAuthError("Неверный логин или пароль");
      // setPreloaderAuthBtn(false);
      return;
    }

    if (loginResponse?.status) {
      setAuthError(`Ошибка сервера: ${loginResponse.status}`);
      return;
    }

    setAuthError('');
    await onSuccessEnter(loginResponse);

  }

  const onResetCloseModal = () => {
    setActiveBtn(false);
    setTwoFactor(false);
  }

  const onSuccessEnter = async (loginResponse) => {
    const userData = await Auth.getMe(loginResponse.accessToken);

    if (loginResponse.accessToken && loginResponse.refreshToken) {
      localStorage.setItem("accessToken", loginResponse.accessToken);
      localStorage.setItem("refreshToken", loginResponse.refreshToken);
    }

    isRememberMe && localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("callIdUserAuth", loginResponse?.id);
    setLoggedIn(true);
    addCurrentUser(userData);
    createUserName(userData);
    setOffset(userData.utcOffset);
    setAuthError('');
    setActiveBtn(false);

    // queryClient.invalidateQueries({ queryKey: ["events"] });

    const subUserId = `${userData.authorities[0].role}${userData.id}`;
    //const subUserId = `${userData.id}`;
    //subscribeToNewEvents(subUserId, config);

    if (eventWaitingIdByLink) {
      handleCurrentEvents({ id: eventWaitingIdByLink }, true);
      return;
    }

    if (eventQuestionsIdByLink) {
      const data = { id: eventQuestionsIdByLink };
      requestHelper(Events.getEvent, data)
          .then((res) => {
            console.log("get Event 165 Authorization");
            // тут вопросик мб не правильная проверка в конце
            handleCurrentEvents(
                data,
                res.status === "ended" ||
                res.status === "quorum_unpresant" ||
                !res.isRegistered
            );
          })
          .catch((err) => {
            throw new Error(err?.message || "Неизвестная ошибка");
          });
      return;
    }

    if (eventResultIdByLink) {
      showEventResult({ id: eventResultIdByLink });
      return;
    }
  }

  const onEnterHandler = (evt) => {
    evt.preventDefault();
    if(authTypes.emailPasswordAndCodeTwoFactor || authTypes.phonePasswordAndCodeTwoFactor) {
      onMethodEnterTwoFactor();
    } else {
      onMethodEnterLogin();
    }
  };

  return (
    isLoadedTypes && (
      <div className="wrapper-auth">
        <div className="container-auth">
          <div className="main-block">
            <div className="main-block__auth">
              <div className="auth__title">
                <h3>Авторизация</h3>
                {/*<div><span>РУС</span><span>ENG</span></div>*/}
              </div>
              <form className="auth__form">
                {authTypes.emailAndPhone && (
                  <div className="auth-form__select-email-phone-container  form__views">
                    Выполнить вход по:
                    <span
                      onClick={() => setEmailView(true)}
                      className={
                        emailView
                          ? "auth-form__select-email active"
                          : "auth-form__select-email"
                      }
                    >
                      E-mail
                    </span>
                    /
                    <span
                      onClick={() => setEmailView(false)}
                      className={
                        phoneView
                          ? "auth-form__select-phone active"
                          : "auth-form__select-phone"
                      }
                    >
                      Телефону
                    </span>
                  </div>
                )}

                {((authTypes && emailView) || authTypes.emailOnly) && (
                  <AuthByEmail
                    authError={authError}
                    authTypes={authTypes}
                    email={email}
                    emailPassword={emailPassword}
                    emailCode={emailCode}
                    setPasswordType={setPasswordType}
                  />
                )}

                {((authTypes && !emailView) || authTypes.phoneOnly) && (
                  <AuthByPhone
                    authError={authError}
                    setAuthError={setAuthError}
                    authTypes={authTypes}
                    phone={phone}
                    phonePassword={phonePassword}
                    phoneCode={phoneCode}
                    setPasswordType={setPasswordType}
                  />
                )}

                <div className="form__checkbox">
                  <div className="checkbox__link-forget-pass-login-secretary">
                    {activeTypeDisplay && (
                      <span
                        className="link-forget-pass"
                        onClick={() => navigate("/forget")}
                      >
                        Забыли пароль?
                      </span>
                    )}
                    <a
                      href={config.admin_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Войти как секретарь
                    </a>
                  </div>
                  <label className="auth-form__checkbox-container">
                    <div className="checkbox_container">
                      <input
                        type="checkbox"
                        checked={isActiveEnterCheck}
                        onChange={() => setIsActiveEnterCheck(!isActiveEnterCheck)}
                      />
                      <span className="checkmark" />
                    </div>
                    <span className="auth__remember-me-checklabel">
                      Запомнить меня
                    </span>
                  </label>
                </div>
                <div
                  className={
                    activeTypeDisplay ? "form__button" : "form__button-spbu"
                  }
                >
                  <button
                    disabled={isNotActiveBtn}
                    className={
                      preLoaderBtn
                        ? "form__button-input-btn active"
                        : "form__button-input-btn"
                    }
                    onClick={onEnterHandler}
                    type="submit"
                  >
                    {preLoaderBtn ? "Загрузка..." : "Войти"}
                  </button>
                  <div className="form__error-phone-code">
                    {authPhoneCodeError}
                  </div>
                  {config.enable_esia && (
                    <a
                      className="form__button__link-gosuslugi"
                      href="https://esia.gosuslugi.ru/login/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Войти через ЕСИА
                    </a>
                  )}
                </div>

                {activeTypeDisplay && (
                  <div className="main-block__mobile-link-reg">
                    <span>Ещё нет аккаунта?</span>
                    <span onClick={() => navigate("/registration")}>
                      Зарегистрироваться
                    </span>
                  </div>
                )}
              </form>
            </div>
            <div className="main-block__reg">
              <div className="reg__logo">
                <img className="reg__logo-main" src={logo} alt="Логотип" />
              </div>
              <div className="reg__title">Система электронных голосований</div>
              {activeTypeDisplay && (
                <div className="reg__button">
                  <span>Еще нет аккаунта?</span>
                  <button onClick={() => navigate("/registration")}>
                    Зарегистрироваться
                  </button>
                </div>
              )}
            </div>
          </div>
          {isTwoFactor && <AuthorizationTwoFactor
              onSuccessEnter={onSuccessEnter}
              isTwoFactor={isTwoFactor}
              onResetCloseModal={onResetCloseModal}
          />}
        </div>
      </div>
    )
  );
};

export default Authorization;
